import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Spinner } from 'react-bootstrap';
import { Images, Camera } from 'react-bootstrap-icons';
import exhibitionService from '../../services/exhibitionService';

const DashboardPage = () => {
  const [stats, setStats] = useState({
    totalExhibitions: 0,
    totalPhotos: 0,
    loading: true
  });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        // Tüm exhibition'ları getir
        const exhibitions = await exhibitionService.getAllExhibitions();
        
        let totalPhotos = 0;
        
        // Her exhibition için fotoğraf sayısını hesapla
        for (const exhibition of exhibitions) {
          try {
            const photos = await exhibitionService.getExhibitionPhotos(exhibition.id);
            totalPhotos += photos.length;
          } catch (error) {
            console.error(`Error fetching photos for exhibition ${exhibition.id}:`, error);
          }
        }

        setStats({
          totalExhibitions: exhibitions.length,
          totalPhotos: totalPhotos,
          loading: false
        });
      } catch (error) {
        console.error('Error fetching dashboard stats:', error);
        setStats({
          totalExhibitions: 0,
          totalPhotos: 0,
          loading: false
        });
      }
    };

    fetchStats();
  }, []);

  if (stats.loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  return (
    <>
      <h2 className="mb-4">Dashboard</h2>
      <Row>
        <Col md={6}>
          <Card className="mb-4 shadow-sm">
            <Card.Body className="d-flex align-items-center">
              <div className="me-3">
                <Images size={48} className="text-primary" />
              </div>
              <div>
                <Card.Title className="mb-1">Total Exhibitions</Card.Title>
                <Card.Text className="h2 mb-0 text-primary">{stats.totalExhibitions}</Card.Text>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={6}>
          <Card className="mb-4 shadow-sm">
            <Card.Body className="d-flex align-items-center">
              <div className="me-3">
                <Camera size={48} className="text-success" />
              </div>
              <div>
                <Card.Title className="mb-1">Total Photos</Card.Title>
                <Card.Text className="h2 mb-0 text-success">{stats.totalPhotos}</Card.Text>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default DashboardPage;